import { Controller } from "@hotwired/stimulus"
import { parse, addDays, subDays, format } from "date-fns";

const DATE_FORMAT = 'yyyy-MM-dd';

export default class extends Controller {
  static targets = ["begin", "end"];

  apply(event) {
    let span = event.target.dataset.span;
    
    if (span) {
      if (this.endTarget.value !== "") {
        let date = parse(this.endTarget.value, DATE_FORMAT, new Date());
  
        this.beginTarget.value = format(subDays(date, span), DATE_FORMAT);
      }
    }

    event.preventDefault();
  }
}
